import { Group, Title } from "@mantine/core";
import type { FC, PropsWithChildren, ReactNode } from "react";

import HelpTourTarget from "src/components/help/HelpTourTarget";
import { helpTourTargets } from "src/help/helpTours";

/**
 * Supplies heading content and optional child actions.
 */
export type PageTitleProps = PropsWithChildren<{}> & {
    title?: ReactNode;
};

/**
 * Renders a page heading and, when truthy, a right-aligned group of child actions.
 */
const PageTitle: FC<PageTitleProps> = ({ title, children }) => {
    return (
        <Group
            justify="space-between"
            align="flex-start"
        >
            <HelpTourTarget id={helpTourTargets.pageTitle}>
                <Title order={2}>{title}</Title>
            </HelpTourTarget>
            {children && (
                <HelpTourTarget id={helpTourTargets.pageActions}>
                    <Group
                        justify="flex-end"
                        gap="xs"
                    >
                        {children}
                    </Group>
                </HelpTourTarget>
            )}
        </Group>
    );
};

export default PageTitle;
